import { ChangeEvent } from "react"

import { DropdownMenu } from "components/inputs/DropdownMenu"

import { DEFAULT_LOCALE, getLanguageName } from "constants/languages"

type LocaleOption = { value: string; name: string }

type Props = {
  activeLocale: string
  addedLocales: string[]
  setActiveLocale: (v: string) => void

  availableToAdd: LocaleOption[]
  onSelectAddLocale: (locale: string) => void

  onRemoveLocale: (locale: string) => void
}

export const PromotionLocalesBar = ({
  activeLocale,
  addedLocales,
  setActiveLocale,
  availableToAdd,
  onSelectAddLocale,
  onRemoveLocale
}: Props) => {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-sm opacity-70 mr-2">Locales:</span>

      {addedLocales.map((l) => {
        const isActive = activeLocale === l
        return (
          <div key={l} className="flex items-center gap-1">
            <button
              type="button"
              onClick={() => setActiveLocale(l)}
              className={["btn btn-sm", isActive ? "btn-primary" : "btn-ghost"].join(" ")}
              title={getLanguageName(l)}
            >
              {l.toUpperCase()}
            </button>

            {l !== DEFAULT_LOCALE && (
              <button
                type="button"
                className="btn btn-sm btn-ghost text-error"
                title={`Remove ${getLanguageName(l)}`}
                onClick={() => onRemoveLocale(l)}
              >
                ✕
              </button>
            )}
          </div>
        )
      })}

      <div className="ml-auto min-w-[260px]">
        <label className="label block mb-1">Add locale</label>

        <DropdownMenu
          title=""
          options={availableToAdd.map((o) => ({
            value: o.value,
            name: `${o.name} (${o.value.toUpperCase()})`
          }))}
          value=""
          onChange={(e: ChangeEvent<HTMLSelectElement>) => {
            const code = e.target.value
            if (!code) return
            onSelectAddLocale(code)
            e.currentTarget.value = ""
          }}
          rounded
        />
      </div>
    </div>
  )
}
